import { forwardRef } from 'react';
import { ButtonViewProps } from './ViewProps';
import { useViewProps } from './useViewProps';
import { withStopPropagation } from './withStopPropagation';

export const ButtonView = forwardRef<HTMLButtonElement, ButtonViewProps>(
  function ButtonViewWithRef(props, ref) {
    const { stopPropagation = true, ...viewProps } = props;
    const {
      children,
      testID,
      type = 'button',
      role,
      onClick,
      onPointerDown,
      ...rest
    } = useViewProps(viewProps);

    return (
      <button
        ref={ref}
        data-testid={testID}
        type={type}
        role={role}
        {...rest}
        onClick={withStopPropagation(onClick, stopPropagation)}
        onPointerDown={withStopPropagation(onPointerDown, stopPropagation)}
      >
        {children}
      </button>
    );
  },
);
